<template>
  <v-dialog v-model="active" persistent max-width="600px">
        <material-card
          color="orange"
          :title="title"
          text="Choose a new PASSWORD"
        >
          <v-form ref="form" v-model="validForm">
            <v-container py-0>
              <v-layout wrap>
              

                <v-flex xs12 md12>
                  <v-text-field
                    autocomplete="false"
                    v-model="changeForm.oldpass"
                    prepend-icon="mdi-lock"
                    :append-icon="
                      passwordType0 == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    @click:append="showPwd0"
                    name="OLD password"
                    label="OLD Password"
                    id="old_password"
                    :type="passwordType0"
                    required
                    :rules="validators.password">
                  </v-text-field>
                </v-flex>

              
                <v-flex xs12 md12>
                  <!-- //BUG ALEXGORR - era passato un boolean invece che un array -->
                  <v-text-field
                    autocomplete="false"
                    v-model="changeForm.newpass"
                    :disabled="!changeForm.oldpass"
                    prepend-icon="mdi-lock"
                    :append-icon="
                      passwordType1 == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    @click:append="showPwd1"
                    name="NEW password"
                    label="NEW Password"
                    id="new_password"
                    :type="passwordType1"
                    required
                    :rules="!changeForm.oldpass ? [] : [
                      ...validators.account.password, 
                      v => validators.different_password(v, changeForm.oldpass),
                      v => validators.password_strong(v),
                      v=> validators.check_simple_password(v)
                      ]"
                  >
                  <!-- //BUG ALEXGORR - era passato un boolean invece che un array -->
                  </v-text-field>
                </v-flex>


                <v-flex xs12 md12>
                  <v-text-field
                    autocomplete="new-password"
                    v-model="changeForm.confirmpass"
                    :disabled="!changeForm.oldpass"
                    prepend-icon="mdi-lock"
                    :append-icon="
                      passwordType2 == 'password' ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    @click:append="showPwd2"
                    name="Confirm NEW password"
                    label="Confirm NEW Password"
                    id="confirm_new_password"
                    :type="passwordType2"
                    required
                    :rules="!changeForm.oldpass ? [] : [...validators.account.password]"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex xs12 text-xs-right>
                  
                  <v-btn
                  v-if="!force"
                    color="primary"
                    class="mx-1 font-weight-light"
                    @click="close()">Close</v-btn>

                  <v-btn
                    color="orange"
                    class="mx-1 font-weight-light"
                    @click="confirm_change"
                    :disabled="!canConfirm()"
                    >Confirm</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
  </v-dialog>
</template>

<script>
//issue 679
import { changePassword } from "@/api/user";
//issue 679
import validators from "@/utils/validators";

//task769
import { isEmulation } from "@/utils/auth";
//task769

export default {
  props: {
    value: false
  },
  data: () => ({
    changeForm: {},
    validForm: true,
    passwordType0: 'password',
    passwordType1: 'password',
    passwordType2: 'password',
    validators
  }),
  watch: {
    value(v) {
      if (v) {
        this.$refs.form.reset();
      }
    },
    'changeForm.oldpass'(newVal) {
      if(!newVal){
        this.changeForm.newpass='';
        this.changeForm.confirmpass='';
      }
    }
  },
  mounted() {
    this.changeForm.restore_pass_token = this.$route.query.restore_pass_token
    this.changeForm.email = this.$route.query.email;
  },
  computed: {
    force(){
      //issue 679
      return this.$store.getters.changePassword.force || false
      //issue 679
    },
    title() {
      //issue 679
      return this.$store.getters.changePassword.title || "Change Password"
      //issue 679
    },
    active() {
      //issue 679
      return (!isEmulation() && this.$store.getters.changePassword.active) || false;
      //issue 679
    },
  },
  methods: {
    close() {
      this.changeForm.oldpass=""
      this.changeForm.newpass=""
      this.changeForm.confirmpass=""
      return this.$store.dispatch("app/closeChangePassword");
    },
    confirm_change(...args) {
      //issue 679
      changePassword(this.changeForm)
      //issue 679
        .then(() => {
          this.$store.dispatch("app/openSnackbar", {
            message: "The new password has been stored correctly!",
            color: "success"
          });
          this.close()
        })
        .catch( e => {
          const error = e.response.data.message;
          this.$store.dispatch("app/openSnackbar", {
            message: "An error occurred during the new password confirmation : " + error,
            color: "error"
          });
        });
    },
    showPwd0 (...args) {
      this.passwordType0 = this.passwordType0 === 'password' ? 'text' : 'password'
    },
    showPwd1 (...args) {
      this.passwordType1 = this.passwordType1 === 'password' ? 'text' : 'password'
    },
    showPwd2 (...args) {
      this.passwordType2 = this.passwordType2 === 'password' ? 'text' : 'password'
    },
    canConfirm() {
      return this.changeForm.confirmpass == this.changeForm.newpass && this.validForm;
    }
  },
 
};
</script>
